export default __webpack_public_path__ + "static/media/logoMICROSOFT_oldLast.80223ef2.png";